import { convertToPhoneNumbers } from "./companyFields";
import { getCountryFormDefinition } from "../cmsUtils";

export interface NewCompanyFormState {
  companyName: string;
  addressLine1: string;
  addressLine2: string;
  postalCode: string;
  city: string;
  country: server.dto.Country;
  state: server.dto.State;
  euVatNumber: string;
  fiscalNumber1: string;
  phoneNumber: string;
  website: string;
  status: server.dto.StatusSmall;
  isArtist: boolean;
  isVenue: boolean;
  isPromoter: boolean;
  capacity: number | undefined;
  googlePlaceId?: string;
  latLng: server.dto.Geo | undefined;
  tags: server.dto.TagSmall[];
}

export const getInitialNewCompanyFormState = (
    serverReference: server.dto.ServerReference,
    userPreference: server.dto.UserPreference,
    statuses: server.dto.StatusSmall[],
    type: "artist" | "venue" | "promoter" | "company",
): NewCompanyFormState => {
  const country = serverReference.countries.find(c => c.key === userPreference.regional.country)!;

  return {
    companyName: "",
    addressLine1: "",
    addressLine2: "",
    postalCode: "",
    city: "",
    country,
    state: country.states.find(s => s.isCountryDefault)!,
    euVatNumber: "",
    fiscalNumber1: "",
    phoneNumber: "",
    website: "",
    status: statuses[0],
    isArtist: type === "artist",
    isVenue: type === "venue",
    isPromoter: type === "promoter",
    capacity: undefined,
    latLng: undefined,
    tags: [],
  };
};

export const getCreateCompanyInstruction = (
    state: NewCompanyFormState,
    serverReference: server.dto.ServerReference,
): server.dto.CreateCompanyInstruction => {
  const formDefinition = getCountryFormDefinition(state.country.key, serverReference);

  return {
    googlePlaceId: state.googlePlaceId,
    isArtist: state.isArtist ? "active" : "no",
    isPromoter: state.isPromoter ? "active" : "no",
    isVenue: state.isVenue ? "active" : "no",
    regularAddress: {
      addressLine1: state.addressLine1,
      addressLine2: state.addressLine2,
      postalCode: state.postalCode,
      city: state.city,
      stateId: state.state?.key,
    },
    regularName: state.companyName,
    fiscalNumber1: formDefinition.fiscalNumber1.displayInUI ? state.fiscalNumber1 : undefined,
    euVatNumber: formDefinition.euVatNumber.displayInUI ? state.euVatNumber : undefined,
    phoneNumbers: convertToPhoneNumbers(state.phoneNumber),
    website: state.website,
    statusId: state.status.statusId,
    venueCapacity: state.isVenue ? state.capacity ?? 0 : 0,
    geoLocation: state.latLng,
    tagsIds: state.tags.map(t => t.tagId),
  };
};
